export default "__VITE_ASSET__DPIIYMk___"